/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { GeneralAttributeStructure } from './GeneralAttributeStructure';
import type { InternationalTextStructure } from './InternationalTextStructure';
import type { LocationRefStructure } from './LocationRefStructure';
import type { NavigationPathStructure } from './NavigationPathStructure';
import type { SituationFullRefStructure } from './SituationFullRefStructure';

export type InterchangeLegStructure = {
  interchangeMode?: InterchangeLegStructure.interchangeMode;
  continuousMode?: InterchangeLegStructure.continuousMode;
  legStart: LocationRefStructure;
  legEnd: LocationRefStructure;
  timeWindowStart?: string;
  timeWindowEnd?: string;
  duration: {
    seconds?: number;
    years?: number;
    months?: number;
    days?: number;
    hours?: number;
    minutes?: number;
    xmlschemaType?: {
      namespaceURI?: string;
      localPart?: string;
      prefix?: string;
    };
    sign?: number;
  };
  walkDuration?: {
    seconds?: number;
    years?: number;
    months?: number;
    days?: number;
    hours?: number;
    minutes?: number;
    xmlschemaType?: {
      namespaceURI?: string;
      localPart?: string;
      prefix?: string;
    };
    sign?: number;
  };
  bufferTime?: {
    seconds?: number;
    years?: number;
    months?: number;
    days?: number;
    hours?: number;
    minutes?: number;
    xmlschemaType?: {
      namespaceURI?: string;
      localPart?: string;
      prefix?: string;
    };
    sign?: number;
  };
  legDescription?: InternationalTextStructure;
  length?: number;
  attribute?: Array<GeneralAttributeStructure>;
  navigationPath?: NavigationPathStructure;
  situationFullRef?: Array<SituationFullRefStructure>;
  extension?: any;
};

export namespace InterchangeLegStructure {
  export enum interchangeMode {
    WALK = 'WALK',
    PARK_AND_RIDE = 'PARK_AND_RIDE',
    BIKE_AND_RIDE = 'BIKE_AND_RIDE',
    CAR_HIRE = 'CAR_HIRE',
    BIKE_HIRE = 'BIKE_HIRE',
    PROTECTED_CONNECTION = 'PROTECTED_CONNECTION',
    GUARANTEED_CONNECTION = 'GUARANTEED_CONNECTION',
    REMAIN_IN_VEHICLE = 'REMAIN_IN_VEHICLE',
    CHANGE_WITHIN_VEHICLE = 'CHANGE_WITHIN_VEHICLE',
    CHECK_IN = 'CHECK_IN',
    CHECK_OUT = 'CHECK_OUT',
  }

  export enum continuousMode {
    WALK = 'WALK',
    DEMAND_RESPONSIVE = 'DEMAND_RESPONSIVE',
    REPLACEMENT_SERVICE = 'REPLACEMENT_SERVICE',
  }
}
